/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ModelVersionFullDto } from '../../models/model-version-full-dto';

export interface ApiModelsVersionsModelVersionIdGet$Params {
  modelVersionId: string;
}

export function apiModelsVersionsModelVersionIdGet(http: HttpClient, rootUrl: string, params: ApiModelsVersionsModelVersionIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelVersionFullDto>> {
  const rb = new RequestBuilder(rootUrl, apiModelsVersionsModelVersionIdGet.PATH, 'get');
  if (params) {
    rb.path('modelVersionId', params.modelVersionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelVersionFullDto>;
    })
  );
}

apiModelsVersionsModelVersionIdGet.PATH = '/api/Models/versions/{modelVersionId}';
